import React, { createContext, useContext, useState } from "react";

const AILoaderContext = createContext<{
  isShowAILoader: boolean;
  setIsShowAILoader: (isShowAILoader: boolean) => void;
  aiLoaderText: string | null;
  setAiLoaderText: (aiLoaderText: string | null) => void;
  clearAILoader: () => void;
}>({
  isShowAILoader: false,
  setIsShowAILoader: () => {},
  aiLoaderText: null,
  setAiLoaderText: () => {},
  clearAILoader: () => {},
});

export const AILoaderProvider = ({ children }: any) => {
  const [isShowAILoader, setIsShowAILoader] = useState(false);
  const [aiLoaderText, setAiLoaderText] = useState<string | null>(null);

  const clearAILoader = () => {
    setIsShowAILoader(false);
    setAiLoaderText(null);
  };

  return (
    <AILoaderContext.Provider
      value={{
        isShowAILoader,
        setIsShowAILoader,
        aiLoaderText,
        setAiLoaderText,
        clearAILoader,
      }}
    >
      {children}
    </AILoaderContext.Provider>
  );
};

export const useAILoader = () => {
  const context = useContext(AILoaderContext);
  if (!context) {
    throw new Error("useAILoader must be used within a AILoaderProvider");
  }
  return context;
};

export default AILoaderContext;
